import gql from 'graphql-tag';

export const getTrainingStatsQuery = gql`
  query GetTrainingStats(
    $userID: String!
    $users: [String!]!
    $startDate: String!
    $endDate: String!
  ) {
    getTrainingStats(
      userID: $userID
      users: $users
      startDate: $startDate
      endDate: $endDate
    ) {
      overallStats {
        pendingAssignTrainings
        inProgressTrainings
        assignedTrainings
        overdueTrainings
        completedTrainings
      }
      directReportsStats {
        user
        stats {
          pendingAssignTrainings
          inProgressTrainings
          assignedTrainings
          overdueTrainings
          completedTrainings
        }
      }
      startDate
      endDate
    }
  }
`;

export const getTrainingCatalogQuery = gql`
  query GetTrainingCatalog {
    getTrainingCatalog {
      error
      nextToken
      status
      trainings {
        auditTime
        deepLink
        duration
        latestVersion
        learnTrainingId
        lms
        media {
          thumbnailAltText
          thumbnailImage
        }
        metrics
        multilingualAttributes {
          description
          isDefaultLanguage
          keywords
          languageId
          trainingTitle
        }
        version
        trainingLanguage
      }
    }
  }
`;

export const getAssignedTrainings = gql`
  query GetAssignedTrainings($input: GetAssignedTrainingsInput!) {
    getAssignedTrainings(input: $input) {
      records {
        assignedDate
        assignmentId
        assignorId
        dueDate
        latestTranscriptTimestamp
        status
        trainingCatalog {
          auditTime
          deepLink
          duration
          latestVersion
          learnTrainingId
          lms
          media {
            thumbnailAltText
            thumbnailImage
          }
          metrics
          multilingualAttributes {
            description
            isDefaultLanguage
            keywords
            languageId
            trainingTitle
          }
          trainingLanguage
          version
        }
        userAlias
        userId
      }
    }
  }
`;
